module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1044-3b9bd73641daeccb07dd83779bb2e1a9.png";